import {
  mergeDefault,
} from "@/components/radar/utils/filterBubbles";
import type { RadarFilterState } from "@/services/api/teacher";

const TALK_FILTER_KEY = {
  admin: "talk.radar.filter.v1:admin",
  teacher: "talk.radar.filter.v1:teacher",
} as const;

export function readTalkFilter(
  role: "admin" | "teacher"
): { filter: RadarFilterState; timeDays: number | null } | null {
  try {
    const raw = localStorage.getItem(TALK_FILTER_KEY[role]);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as {
      filter?: Partial<RadarFilterState>;
      timeDays?: unknown;
    };
    const timeDays =
      typeof parsed.timeDays === "number" && Number.isFinite(parsed.timeDays)
        ? parsed.timeDays
        : null;
    return { filter: mergeDefault(parsed.filter, role), timeDays };
  } catch {
    return null;
  }
}

export function writeTalkFilter(
  role: "admin" | "teacher",
  filter: RadarFilterState,
  timeDays: number
) {
  try {
    localStorage.setItem(
      TALK_FILTER_KEY[role],
      JSON.stringify({ filter, timeDays })
    );
  } catch {
    return;
  }
}
